
/*
  Saves data to a JSON file in the S3 Bucket datarequests/company-name/public
  < input = jsonData (as a string), fileName >
*/

export async function saveJsonToS3Bucket(S3, jsonData, fileName, newRequestData, company, isSubmitted, isMerged) {
  const bucketName = process.env.REACT_APP_S3_DATAREQUESTS_BUCKET; 
  const objectKey = `${company}/public/${fileName}.json`; 
  const prefix = process.env.REACT_APP_HOST_PREFIX;

  //Tags
  const memberName = newRequestData.MemberName;
  const phone = newRequestData.Phone;
  const assignedProperties = (newRequestData.AssignedProperties).split(",").join("");
  const requestFormLink = fileName;
  const snapshotName = newRequestData.SnapshotName;

  try {
    // console.log("data sent to s3: ",jsonData)
    // console.log("newRequestData: ", newRequestData)
    console.log("tags: ",memberName+" "+phone+" "+assignedProperties)
    const params = {
      Bucket: bucketName,
      Key: objectKey,
      Body: jsonData,
      ContentType: "application/json",
      Tagging: `MemberName=${memberName}&Phone=${phone}&AssignedProperties=${assignedProperties}&RequestFormLink=${requestFormLink}&Status=${isSubmitted ? "Completed": isMerged ? "Merged" : "In Progress"}&Filename=${snapshotName}`
    //   ACL: "public-read", // Ensure this matches your bucket's policy for public access
    };

    // Upload the file to S3
    const s3Response = await S3.putObject(params).promise();
    console.log('Successfully uploaded JSON to S3:', s3Response);

    // Return the URL of the uploaded file
    return `${prefix}/${company}/${fileName}`;

  } catch (error) {
    console.error('Error uploading JSON to S3:', error);
    return null;
  }
}